import React from 'react';

import { SVG } from '.';

export interface IProps {
    className?: string,
    size?: 'm' | 'l'
}

export const IconLogoChinese = (props: IProps) => {
    return (
        <SVG
            width="32"
            height="16"
            viewBox="0 0 32 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M8.12073 6.528H15.3047V8.144H8.12073V6.528ZM8.12073 9.68H15.3047V11.296H8.12073V9.68ZM7.91273 12.896H16.0247V14.64H7.91273V12.896ZM11.0327 4.272H12.8087V13.408H11.0327V4.272ZM12.0407 0.447999L14.0727 0.863999C13.5127 2.256 12.8247 3.76 12.2967 4.72L10.6487 4.304C11.1767 3.264 11.7527 1.648 12.0407 0.447999ZM8.37673 0.384L10.2167 0.848C9.44874 3.472 8.15273 6.112 6.61673 7.76C6.37673 7.36 5.76873 6.48 5.40073 6.064C6.72873 4.736 7.78473 2.592 8.37673 0.384ZM9.16074 3.344H15.7207V5.024H9.16074V15.424H7.32073V4.288L8.26473 3.344H9.16074ZM0.872734 8.592C2.21673 8.32 4.21673 7.824 6.12073 7.344L6.34473 9.04C4.60073 9.552 2.74473 10.064 1.27273 10.464L0.872734 8.592ZM1.19273 3.456H6.13673V5.216H1.19273V3.456ZM3.08073 0.431999H4.92073V13.28C4.92073 14.224 4.76073 14.736 4.23273 15.04C3.70473 15.36 2.93673 15.424 1.84873 15.424C1.78473 14.912 1.54473 14.08 1.30473 13.552C1.92873 13.584 2.58473 13.584 2.79273 13.584C3.00073 13.584 3.08073 13.504 3.08073 13.28V0.431999ZM19.5447 2.448H31.6407V4.288H19.5447V2.448ZM18.6487 2.448H20.5847V6.8C20.5847 9.328 20.2807 13.168 18.5207 15.504C18.2167 15.152 17.4007 14.464 16.9687 14.24C18.5207 12.128 18.6487 9.04 18.6487 6.784V2.448ZM24.0567 0.415999H26.0567V3.44H24.0567V0.415999Z"
                fill="#8F93A3"
            />

        </SVG>
    );
};
